import React from "react"

import { Prices } from "packages/ui-shared/components/Prices"

import { productCardPrices } from "./ProductCard.css"
import type { ProductCardDataType } from "./types"

type Props = {
  product: Pick<
    ProductCardDataType,
    | "primaryPrice"
    | "primarySubtitle"
    | "secondaryPrice"
    | "secondarySubtitle"
    | "highlightedPrice"
  >
}

export const ProductCardPrices: React.FC<Props> = ({ product }) => {
  if (!product.primaryPrice || !product.secondaryPrice) return null

  return (
    <div className={productCardPrices}>
      <Prices
        primaryPrice={product.primaryPrice}
        primarySubtitle={product.primarySubtitle}
        secondaryPrice={product.secondaryPrice}
        secondarySubtitle={product.secondarySubtitle}
        highlightedPrice={product.highlightedPrice}
      />
    </div>
  )
}
